/**
 * HELP ARTICLES STORE
 */

import Vue from "vue";
import api from "Api";
import router from "Router";

const state = {
    help_articles: [],
};

// getters
const getters = {
    help_articles: (state) => {
        return state.help_articles;
    },
};

// actions
const actions = {
    async fetchHelp({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;
            /*let message = {
                html: '',
                type: '',
                icon: 'fa-warning',
                timeout: 2500,
            }*/

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (payload.commit) {
                    commit("mutateArticles", {
                        property: payload.stateProperty,
                        with: response.data[payload.dataProperty ? payload.dataProperty : payload.stateProperty],
                    });
                    if (payload.localStorage) {
                        localStorage.setItem(
                            payload.stateProperty,
                            JSON.stringify(response.data[payload.dataProperty ? payload.dataProperty : payload.stateProperty])
                        );
                    }
                }
                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    mutateArticles(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    resetHelp(state) {
        state.help_articles = [];
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
